import routerOptions0 from "/home/runner/work/rediredi-storefront/rediredi-storefront/app/router.options.ts";
import routerOptions1 from "/home/runner/work/rediredi-storefront/rediredi-storefront/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}